import React, { Component, type ErrorInfo, type ReactNode } from 'react';
import ComercialManagement from '@crm/components/Comercial/ComercialManagement';
import '@crm/components/Comercial/ComercialManagement.css';

type Props = {
  onClose: () => void;
  /** Load associate marcações from CCC Recuperação (claimed clients with proposals). */
  gestaoCccRecuperacao?: boolean;
};

type ErrorBoundaryState = { error: Error | null };

class SignatureOverlayErrorBoundary extends Component<
  { children: ReactNode; onClose: () => void },
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[CccPedirAssinaturaDigitalOverlay] render failed', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="rec-gestao-modals-overlay" role="dialog" aria-modal="true">
          <div className="rec-gestao-modals-error">
            <p>Não foi possível abrir Pedir Assinatura Digital.</p>
            <button type="button" className="rec-btn rec-btn-primary" onClick={this.props.onClose}>
              Fechar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

/** Host Pedir Assinatura Digital from CCC (same modal as Comercial Gestão). */
const CccPedirAssinaturaDigitalOverlay: React.FC<Props> = ({
  onClose,
  gestaoCccRecuperacao = false,
}) => (
  <div className="rec-gestao-modals-overlay gestao-marcacoes" role="presentation">
    <SignatureOverlayErrorBoundary onClose={onClose}>
      <ComercialManagement
        embeddedSignatureOnly
        gestaoCccRecuperacao={gestaoCccRecuperacao}
        onEmbeddedSignatureClose={onClose}
      />
    </SignatureOverlayErrorBoundary>
  </div>
);

export default CccPedirAssinaturaDigitalOverlay;
